// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav__2etB5","active":"active__RjRdm"};